import { render, staticRenderFns } from "./SwitchTile.vue?vue&type=template&id=3f91669b&"
import script from "./SwitchTile.vue?vue&type=script&lang=js&"
export * from "./SwitchTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports